export default __webpack_public_path__ + "assets/end-results.a3477178.svg";